/**
 * exerciseMedia — normalize exercise GIF/image URLs.
 *
 * The original media host (static.exercisedb.dev) went behind a paywall and now
 * geo/WAF-blocks browsers (HTTP 403), so ~97% of the catalog lost its images.
 * We re-hosted every GIF to our own Cloudinary; the DB was migrated too. But
 * exercise objects snapshotted into routines, workout sessions, social posts,
 * and clients' cached React Query / localStorage data may still carry the dead
 * URL. This helper rewrites any such URL to its Cloudinary equivalent at render
 * time, so those surfaces self-heal without a data migration reaching them.
 *
 * The mapping is deterministic: the GIF filename equals the Cloudinary
 * public_id (verified across all 1492 exercises), so we swap only the host/path
 * prefix and keep the filename.
 */

const DEAD_PREFIX = '://static.exercisedb.dev/media/';
const CLOUDINARY_EXERCISES_PREFIX =
  'https://res.cloudinary.com/dktxfosnu/image/upload/trainedbyrs/exercises/';

/**
 * Rewrite a dead exercisedb.dev media URL to its Cloudinary equivalent.
 * Returns other URLs (and empty/nullish values) unchanged.
 */
export function normalizeExerciseMediaUrl(url) {
  if (!url || typeof url !== 'string') return url;
  const idx = url.indexOf(DEAD_PREFIX);
  if (idx === -1) return url;
  const filename = url.slice(idx + DEAD_PREFIX.length);
  return CLOUDINARY_EXERCISES_PREFIX + filename;
}
